// extracted by mini-css-extract-plugin
module.exports = {"page":"Home_page__z25kN","hero":"Home_hero__g_og0","tagline":"Home_tagline__Jw01K","cta":"Home_cta__8vVJ9","button":"Home_button__Mzpzz"};